// utils/groupCallSignaling.js
import { connectSocket } from "../socket";

export function createGroupCallSignaling(localUser, groupId) {
  const socket = connectSocket();

  function joinGroupCall(type) {
    socket.emit("group_call_join", { groupId, user: localUser, type });
  }

  function sendOffer(to, offer, type) {
    socket.emit("group_call_offer", { to, from: localUser, offer, groupId, type });
  }

  function sendAnswer(to, answer) {
    socket.emit("group_call_answer", { to, from: localUser, answer, groupId });
  }

  function sendICE(to, candidate) {
    socket.emit("group_call_ice", { to, from: localUser, candidate, groupId });
  }

  function leaveGroupCall() {
    socket.emit("group_call_leave", { groupId, user: localUser });
  }

  function cleanup() {
    socket.off("group_call_user_joined");
    socket.off("group_call_offer");
    socket.off("group_call_answer");
    socket.off("group_call_ice");
    socket.off("group_call_user_left");
    socket.off("group_call_ended");
  }

  return {
    joinGroupCall,
    sendOffer,
    sendAnswer,
    sendICE,
    leaveGroupCall,
    cleanup,
    socket
  };
}